<template>
  <v-dialog v-model="dialog" width="620px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>Sửa trạng thái hoạt động của đồng phục</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-row class="mb-4">
          <v-col cols="12" class="mt-4 pb-2"
            ><div class="d-flex align-center">
              <v-avatar size="64" class="mr-4">
                <v-img :src="getImageUrl(uniformData)" />
              </v-avatar>
              <div>
                <h3 class="mb-1">{{ uniformData.name }}</h3>
              </div>
            </div>
          </v-col>
          <!-- Trạng thái hiện tại -->
          <v-col cols="12" style="padding-bottom: 0px; height: 50px">
            <v-divider />
            <div class="mt-4">
              <span> Chuyển trạng thái</span>
            </div>
          </v-col>
          <v-col cols="5" style="align-content: center; padding-bottom: 0px; padding-top: 0px; height: 60px">
            <v-chip :color="getStatusColor(uniformData.activeStatus)" small class="white--text">
              {{ getStatusText(uniformData.activeStatus) }}
            </v-chip>
          </v-col>
          <v-col
            cols="2"
            class="text-center"
            style="align-content: center; padding-bottom: 0px; padding-top: 0px; height: 60px"
          >
            <v-icon color="grey" size="36">mdi-arrow-right</v-icon>
          </v-col>
          <v-col cols="5" style="align-content: center; padding-bottom: 0px; padding-top: 0px; height: 60px">
            <v-select v-model="newStatus" :items="statusOptions" label="Trạng thái mới" outlined dense hide-details />
          </v-col>
          <v-col cols="12" class="pb-0">
            <v-divider />
          </v-col>
        </v-row>
        <div class="fix-height-dialog-uc">
          <v-row>
            <v-col cols="12">
              <div class="mb-2">
                <span style="font-weight: bold">Danh sách phân loại</span>
              </div>
              <div v-if="uniformData.uniformCombinations && uniformData.uniformCombinations.length">
                <ul style="margin-top: 5px; list-style-type: none; padding-left: 10px">
                  <li v-for="(comb, index) in uniformData.uniformCombinations" :key="index">
                    <v-list-item-content
                      :style="{
                        color: comb.isActive ? '#000' : '#B0B0B0',
                        textDecoration: comb.isActive ? '' : 'line-through',
                        paddingTop: '0px',
                        paddingBottom: '4px',
                      }"
                    >
                      {{ comb.optionOne && comb.optionOne.name }} -

                      {{ comb.optionTwo && comb.optionTwo.name }}

                      - {{ Number(comb.price).toLocaleString('vi-VN') }} (VNĐ)
                    </v-list-item-content>
                  </li>
                </ul>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn outlined class="grey--text" @click="cancel">HUỶ</v-btn>
        <v-btn color="primary" @click="confirmChange">LƯU</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  components: {},
  props: {
    state: Boolean,
    uniformData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialog: false,
      newStatus: '',
      statusOptions: [
        { value: 'working', text: 'Đang hoạt động' },
        { value: 'pause', text: 'Tạm dừng' },
      ],
    }
  },
  methods: {
    ...mapActions('Uniformes', ['updateUniform']),

    getImageUrl(uniform) {
      return uniform.images && uniform.images.length ? uniform.images[0].url : ''
    },

    getStatusColor(status) {
      switch (status) {
        case 'working':
          return '#4CAF50' // Màu xanh lá cây - Đang hoạt động
        case 'pause':
          return '#FFA726' // Màu cam - Tạm dừng
        default:
          return '#9E9E9E' // Màu xám tối - Không xác định
      }
    },
    getStatusText(status) {
      const statusTexts = {
        working: 'Đang hoạt động',
        pause: 'Tạm dừng',
      }
      return statusTexts[status] || 'Không xác định'
    },
    cancel() {
      this.dialog = false
    },
    async confirmChange() {
      if (!this.newStatus) {
        this.$alert.error('Vui lòng chọn trạng thái mới')
        return
      }
      this.$loading.active = true
      try {
        await this.updateUniform({
          ...this.uniformData,
          id: this.uniformData._id,
          activeStatus: this.newStatus,
        })
        this.$alert.addSuccess('Cập nhật trạng thái thành công!')
        this.$emit('updated')
        this.dialog = false
      } catch (error) {
        console.error(error)
        this.$alert.addError('Có lỗi xảy ra khi cập nhật trạng thái!')
      } finally {
        this.$loading.active = false
      }
    },
  },
  watch: {
    state(val) {
      if (val) {
        this.dialog = true
        this.newStatus = this.uniformData.activeStatus === 'working' ? 'pause' : 'working'
      }
    },
  },
}
</script>

<style scoped>
.text-muted {
  color: #888;
  font-size: 14px;
}
.fix-height-dialog-uc {
  height: 200px;
  max-height: 500px;
  overflow: auto;
  padding-right: 18px;
}
.total-price-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
  font-weight: bold;
}
ul {
  list-style-type: disc !important;
  margin-left: 20px;
}
</style>
